export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7369_82725)">
                <path d="M8.3 16.5L5 24.5H27L23.7 16.5H8.3Z" stroke="black" strokeWidth="1.2" strokeLinejoin="round" />
                <path d="M7 6.5L8.41666 16.5" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25 6.5L23.5833 16.5" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 4.5V16.5" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M5 24.5V26.7C5 27.1418 5.35817 27.5 5.8 27.5H26.2C26.6418 27.5 27 27.1418 27 26.7V24.5"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_7369_82725">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
